export default function authHeader() {
  // Intentar obtener el token de auth_token primero
  let token = localStorage.getItem("auth_token");
  
  // Si no existe, intentar con el método anterior
  if (!token) {
    token = JSON.parse(localStorage.getItem("userF"));
  }

  if (token) {
    return {
      Authorization: "Bearer " + token,
      "Content-Type": "application/vnd.api+json",
    };
  } else {
    return {};
  }
}